import { useRef, useCallback } from 'react';

export const useScrollToComments = () => {
  const commentsWrapperRef = useRef(null);
  const highlightedCommentRef = useRef(null);

  const scrollToContent = useCallback(() => {
    setTimeout(() => {
      if (highlightedCommentRef.current) {
        highlightedCommentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 1000);
  }, []);

  return {
    commentsWrapperRef,
    highlightedCommentRef,
    scrollToContent
  };
};
